import { useCallback, useEffect, useState } from 'react';

export type ThemesCategoriesStatus = 'active' | 'inactive';

export type ThemesCategoriesFilterDraft = {
  status: ThemesCategoriesStatus[];
};

type UseThemesCategoriesDrawerFiltersParams = {
  isOpen: boolean;
  onClose: () => void;
  onApplyFilters: (filters: ThemesCategoriesFilterDraft) => void;
  appliedFilters: ThemesCategoriesFilterDraft | null;
};

const createEmptyDraft = (): ThemesCategoriesFilterDraft => ({ status: [] });

const cloneDraft = (draft: ThemesCategoriesFilterDraft | null): ThemesCategoriesFilterDraft => ({
  status: [...(draft?.status || [])],
});

export default function useThemesCategoriesDrawerFilters({
  isOpen,
  onClose,
  onApplyFilters,
  appliedFilters,
}: UseThemesCategoriesDrawerFiltersParams) {
  const [draftFilters, setDraftFilters] = useState<ThemesCategoriesFilterDraft>(() =>
    cloneDraft(appliedFilters)
  );

  useEffect(() => {
    if (isOpen) {
      setDraftFilters(cloneDraft(appliedFilters));
    }
  }, [appliedFilters, isOpen]);

  const handleChangeStatus = useCallback((status: ThemesCategoriesStatus[]) => {
    setDraftFilters({ status: Array.from(new Set(status)) });
  }, []);

  const handleApply = useCallback(() => {
    onApplyFilters(cloneDraft(draftFilters));
    onClose();
  }, [draftFilters, onApplyFilters, onClose]);

  const handleClear = useCallback(() => {
    const emptyDraft = createEmptyDraft();
    setDraftFilters(emptyDraft);
    onApplyFilters(emptyDraft);
  }, [onApplyFilters]);

  return {
    draftFilters,
    statusOptions: [
      { label: 'Ativo', value: 'active' as const },
      { label: 'Inativo', value: 'inactive' as const },
    ],
    handleChangeStatus,
    handleApply,
    handleClear,
  };
}
